/**
 * Store извън React – интервалът и данните не зависят от монтиране/размонтиране.
 * Така мониторингът не се рестартира при Strict Mode или навигация.
 */
const MAX_DATA_POINTS = 30;

function generateMockData() {
  const baseTemp = 22;
  const baseSmoke = 0.01;
  const baseBattery = 85;
  const temperature = baseTemp + (Math.random() * 4 - 2);
  const smokeLevel = Math.max(0, baseSmoke + (Math.random() * 0.02 - 0.01));
  const battery = Math.max(0, Math.min(100, baseBattery + (Math.random() * 2 - 1)));
  return {
    temperature: parseFloat(temperature.toFixed(1)),
    smoke_level: parseFloat(smokeLevel.toFixed(4)),
    battery: Math.round(battery),
    timestamp: new Date().toISOString()
  };
}

const state = {
  monitoringActive: false,
  currentData: null,
  tempData: [],
  smokeData: [],
  timeLabels: []
};

let intervalId = null;
const listeners = new Set();

function createSnapshot() {
  return {
    monitoringActive: state.monitoringActive,
    currentData: state.currentData,
    tempData: [...state.tempData],
    smokeData: [...state.smokeData],
    timeLabels: [...state.timeLabels]
  };
}

function emit() {
  const snap = createSnapshot();
  listeners.forEach((cb) => {
    try {
      cb(snap);
    } catch (e) {
      console.warn('[realtimeMonitoringStore] listener error', e);
    }
  });
}

function updateChartData(data) {
  const now = new Date().toLocaleTimeString('bg-BG');
  state.timeLabels = [...state.timeLabels, now].slice(-MAX_DATA_POINTS);
  if (data.temperature !== undefined) {
    state.tempData = [...state.tempData, data.temperature].slice(-MAX_DATA_POINTS);
  }
  if (data.smoke_level !== undefined) {
    state.smokeData = [...state.smokeData, data.smoke_level * 100].slice(-MAX_DATA_POINTS);
  }
}

export function startMonitoring() {
  if (intervalId !== null) return;
  state.monitoringActive = true;
  state.currentData = generateMockData();
  updateChartData(state.currentData);
  try {
    sessionStorage.setItem('fireguard_realtime_monitoring_active', 'true');
  } catch (_) {}
  intervalId = setInterval(() => {
    state.currentData = generateMockData();
    updateChartData(state.currentData);
    emit();
  }, 2000);
  emit();
}

export function stopMonitoring() {
  if (intervalId !== null) {
    clearInterval(intervalId);
    intervalId = null;
  }
  state.monitoringActive = false;
  try {
    sessionStorage.setItem('fireguard_realtime_monitoring_active', 'false');
  } catch (_) {}
  emit();
}

/** Обновяване от външен източник (напр. WebSocket) */
export function updateRealtimeData(data) {
  state.currentData = data;
  updateChartData(data);
  emit();
}

export function subscribe(callback) {
  listeners.add(callback);
  callback(createSnapshot());
  return () => listeners.delete(callback);
}

export function getState() {
  return createSnapshot();
}

/** Само за тестове – изчиства данните, не спира интервала (извикай stopMonitoring преди) */
export function resetForTesting() {
  state.monitoringActive = false;
  state.currentData = null;
  state.tempData = [];
  state.smokeData = [];
  state.timeLabels = [];
}

export { MAX_DATA_POINTS };
